import { Link } from 'react-router-dom';
import { TimelinesWrapper } from '@/partials/timelines/default/item';
import { toTitleCase } from '@/utils/String';
import { activitySentence } from './activitySentence';

const containsHtml = (str) => /<\/?[a-z][\s\S]*>/i.test(str);

const stripHtml = (html) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};

const truncate = (text, maxLength = 100) => {
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
};

const formatValue = (val) => {
  if (val === null || val === '' || val === undefined || val === 'null') return 'N/A';

  if (val === 1) return 'Yes';
  if (val === 0) return 'No';

  const valueStr = String(val);

  if (containsHtml(valueStr)) {
    return truncate(stripHtml(valueStr));
  }

  return valueStr;
};

const ActivitiesLog = ({ activityData }) => {
  if (!activityData || activityData.length === 0) {
    return (
      <div className="text-sm text-gray-600 italic">
        No recent activity found.
      </div>
    );
  }

  return (
    <>
      {activityData.map((activity, index) => {
        const userFullName = `${activity?.user?.first_name || ''} ${activity?.user?.last_name || ''}`;

        const oldData = activity?.data || {};
        const newData = activity?.current_data || {};

        const changedFields = [];

        if (activity?.log_type === 'edit') {
          Object.keys(newData).forEach((key) => {
            // A stage change gets its own row with the stage names (OL-209).
            if (key === 'updated_at' || key === 'stage_id') return;

            const oldVal = oldData[key];
            const newVal = newData[key];

            if (oldVal !== newVal) {
              const displayOld = formatValue(oldVal);
              const displayNew = formatValue(newVal);


              changedFields.push(
                `${toTitleCase(key)} changed from '${displayOld}' to '${displayNew}'`
              );
            }
          });
        }

        return (
          <TimelinesWrapper icon="share" line={true} key={index}>
            <div className="flex flex-col mb-2">
              <div className="text-sm text-gray-800">
                {userFullName} {activitySentence(activity)}

                {changedFields.length > 0 && (
                  <>
                    :&nbsp;
                    <ul className="list-disc ml-5">
                      {changedFields.map((field, idx) => (
                        <li key={idx} className="text-xs text-gray-700">{field}</li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
              <span className="text-xs text-gray-600">
                {activity?.humanize_datetime || 'No timestamp available'}
              </span>
            </div>
          </TimelinesWrapper>
        );
      })}
    </>
  );
};

export { ActivitiesLog };